module.exports = __webpack_public_path__ + "img/eg-24-01.12661915.jpg";